import { lineupKeys } from "./publicKeys";


export default function getPlayerLineup(playerInfos, position) {

    let playerlineup = null

    lineupKeys.map((lineup, index) => {
        if(playerInfos[lineup] == position) {
            playerlineup = lineup;
        }
    })

    return playerlineup;
}